import type { Slider } from "./Slider";
import { SliderElementSettings } from "./sliderTypes";

export class SliderElement {
  id: string;

  numberInputWrapper: HTMLDivElement;

  numberInputMinContainer: HTMLDivElement;

  numberInputMin: HTMLInputElement;

  numberInputMinLabel: HTMLLabelElement;

  numberInputMaxContainer: HTMLDivElement;

  numberInputMax: HTMLInputElement;

  numberInputMaxLabel: HTMLLabelElement;

  rangeInputWrapper: HTMLDivElement;

  inverseLeft: HTMLDivElement;

  range: HTMLDivElement;

  inverseRight: HTMLDivElement;

  thumbMin: HTMLSpanElement;

  thumbMax: HTMLSpanElement;

  rangeInputMin: HTMLInputElement;

  rangeInputMax: HTMLInputElement;

  constructor(settings: SliderElementSettings, slider: Slider) {
    this.id = settings.id || window.o_util.misc.guid();

    this.numberInputWrapper = document.createElement("div");
    this.numberInputMinContainer = document.createElement("div");
    this.numberInputMin = document.createElement("input");
    this.numberInputMinLabel = document.createElement("label");
    this.numberInputMaxContainer = document.createElement("div");
    this.numberInputMax = document.createElement("input");
    this.numberInputMaxLabel = document.createElement("label");

    /*                                         */
    this.numberInputWrapper.classList.add("pl_slider__input-wrapper", "pl_input--floating-label");
    if (settings.showDefaultPlaceholders === false) {
      this.numberInputWrapper.classList.add("pl_input--hide-placeholders");
    }

    this.numberInputMinContainer.classList.add("pl_input", "js-pl_input");
    this.numberInputMin.classList.add("pl_input__field");
    this.numberInputMinLabel.classList.add("pl_label", "js-pl_label");

    this.numberInputMaxContainer.classList.add("pl_input", "js-pl_input");
    this.numberInputMax.classList.add("pl_input__field");
    this.numberInputMaxLabel.classList.add("pl_label", "js-pl_label");

    /*                                        */
    this.numberInputMin.setAttribute("type", "number");
    this.numberInputMinLabel.innerText = settings.minLabel;

    this.numberInputMax.setAttribute("type", "number");
    this.numberInputMaxLabel.innerText = settings.maxLabel;

    /*                                                                    */
    this.numberInputMin.max = slider.maxVal.toString();
    this.numberInputMin.placeholder = slider.minVal.toString();

    this.numberInputMax.min = slider.minVal.toString();
    this.numberInputMax.placeholder = slider.maxVal.toString();

    /*                                */
    this.numberInputMinContainer.appendChild(this.numberInputMin);
    this.numberInputMinContainer.appendChild(this.numberInputMinLabel);

    this.numberInputMaxContainer.appendChild(this.numberInputMax);
    this.numberInputMaxContainer.appendChild(this.numberInputMaxLabel);

    /*                                      */
    if (settings.inputPrefixIcon || settings.inputPrefixText) {
      [this.numberInputMinContainer, this.numberInputMaxContainer].forEach((container) => {
        container.classList.add("pl_input__prefix");
        container.appendChild(
          SliderElement.buildAdditionalElement(settings.inputPrefixIcon, settings.inputPrefixText),
        );
      });
    } else if (settings.inputSuffixIcon || settings.inputSuffixText) {
      [this.numberInputMinContainer, this.numberInputMaxContainer].forEach((container) => {
        container.classList.add("pl_input__suffix");
        container.appendChild(
          SliderElement.buildAdditionalElement(
            settings.inputSuffixIcon,
            settings.inputSuffixText,
            false,
          ),
        );
      });
    }

    if (settings.focusFloatsBothLabels) {
      this.numberInputMin.addEventListener("focus", () => {
        this.numberInputWrapper.classList.toggle("pl_input--field-has-focus");
      });
      this.numberInputMin.addEventListener("blur", () => {
        this.numberInputWrapper.classList.toggle("pl_input--field-has-focus");
      });
      this.numberInputMax.addEventListener("focus", () => {
        this.numberInputWrapper.classList.toggle("pl_input--field-has-focus");
      });
      this.numberInputMax.addEventListener("blur", () => {
        this.numberInputWrapper.classList.toggle("pl_input--field-has-focus");
      });
    }

    this.numberInputWrapper.appendChild(this.numberInputMinContainer);
    this.numberInputWrapper.appendChild(this.numberInputMaxContainer);

    this.rangeInputWrapper = document.createElement("div");

    this.inverseLeft = document.createElement("div");
    const inverseLeftInner = document.createElement("div");
    this.range = document.createElement("div");
    const rangeInner = document.createElement("div");
    this.inverseRight = document.createElement("div");
    const inverseRightInner = document.createElement("div");

    this.rangeInputMin = document.createElement("input");
    this.rangeInputMax = document.createElement("input");

    this.thumbMin = document.createElement("span");
    this.thumbMax = document.createElement("span");

    /*                                        */
    this.rangeInputWrapper.classList.add("pl_slider__range-wrapper");

    this.inverseLeft.classList.add("pl_slider__inverse-left");
    inverseLeftInner.classList.add("pl_slider__inverse__inner");
    this.range.classList.add("pl_slider__range");
    rangeInner.classList.add("pl_slider__range__inner");
    this.inverseRight.classList.add("pl_slider__inverse-right");
    inverseRightInner.classList.add("pl_slider__inverse__inner");

    this.rangeInputMin.classList.add("pl_slider__range--min");
    this.rangeInputMax.classList.add("pl_slider__range--max");

    this.thumbMin.classList.add("pl_slider__thumb-min");
    this.thumbMax.classList.add("pl_slider__thumb-max");

    /*                                       */
    this.rangeInputMin.setAttribute("type", "range");
    this.rangeInputMin.setAttribute("tabindex", "0");
    this.rangeInputMax.setAttribute("type", "range");
    this.rangeInputMax.setAttribute("tabindex", "0");

    /*                                                                   */
    this.rangeInputMin.min = slider.minPos.toString();
    this.rangeInputMin.max = slider.maxPos.toString();
    this.rangeInputMin.value = slider.minPos.toString();

    this.rangeInputMax.min = slider.minPos.toString();
    this.rangeInputMax.max = slider.maxPos.toString();
    this.rangeInputMax.value = slider.maxPos.toString();

    /*                               */
    this.inverseLeft.appendChild(inverseLeftInner);
    this.range.appendChild(rangeInner);
    this.inverseRight.appendChild(inverseRightInner);

    this.rangeInputWrapper.appendChild(this.inverseLeft);
    this.rangeInputWrapper.appendChild(this.range);
    this.rangeInputWrapper.appendChild(this.inverseRight);
    this.rangeInputWrapper.appendChild(this.rangeInputMin);
    this.rangeInputWrapper.appendChild(this.rangeInputMax);
    this.rangeInputWrapper.appendChild(this.thumbMin);
    this.rangeInputWrapper.appendChild(this.thumbMax);
  }

  /**
 *
 *
 *
 *
 */
  getNumberInputMinValue(): string {
    return this.numberInputMin.value === ""
      ? this.numberInputMin.placeholder
      : this.numberInputMin.value;
  }

  getNumberInputMaxValue(): string {
    return this.numberInputMax.value === ""
      ? this.numberInputMax.placeholder
      : this.numberInputMax.value;
  }

  static buildAdditionalElement(
    inputIcon?: string,
    inputText?: string,
    prefix = true,
  ): SVGSVGElement | HTMLElement {
    const icon = inputIcon?.match(/^pl_icon_.*/);

    if (icon) {
      const prefixSvg = document.createElementNS("http:/*                           */
      prefixSvg.classList.add("pl_icon", prefix ? "pl_input__prefix" : "pl_input__suffix");
      prefixSvg.setAttribute("role", "img");
      prefixSvg.innerHTML = `<use href="/assets-static/icons/${icon[0]}.svg#${icon[0]}" xlink:href="/assets-static/icons/${icon[0]}.svg#${icon[0]}"></use>`;
      return prefixSvg;
    }

    const prefixText = document.createElement("small");
    prefixText.classList.add("pl_input__note", prefix ? "pl_input__prefix" : "pl_input__suffix");
    prefixText.innerText = inputText || "";
    return prefixText;
  }
}
